module.exports = __webpack_public_path__ + "static/media/google.d3dbec20.svg";